<template>
	<div>
		  <Breadcrumbs main="Technician" title="Add Product" />
			 <div class="container-fluid">
				<div class="row">
				   <div class="col-sm-12">
					  <div class="card">
						 <div class="card-body">
 
							<div class="row mb-3">
							   	<div class="col-12">
									<a href="#" @click.prevent="handleGoBack" class="btn btn-primary float-end"><i class='bx bx-chevrons-left'></i> Back</a>
							   	</div>
							</div>
 
							<form  @submit.prevent="addTechnicianProducts" enctype="multipart/form-data">
								<div class="form theme-form">
									<div class="row">
										<div class="col-md-4">
											<div class="mb-3">
												<label class="control-label">Product Name<span class="text-danger">*</span></label>
												<select class="form-select" v-model="product_id">
													<option value="">Choose Product</option>
													<option :value="product.id" v-for="(product, index) in products" :key="index">
														{{ product.product_name }}
													</option>
												</select>
												<span class="validate-error" v-if="errors.product_id">
													{{ errors.product_id[0] }}
												</span>
											</div>
										</div>
									
										<div class="col-md-4">
											<div class="mb-3">
												<label class="control-label">Stock<span class="text-danger">*</span></label>
												<input class="form-control" type="number" placeholder="" v-model="product_stock"/>
												<span class="validate-error" v-if="errors.quantity">
													{{ errors.quantity[0] }}
												</span>
											</div>
										</div>
										
									</div>

									<div class="row mt-3">
										<div class="col-sm-12">
											<button class="btn btn-success me-2 float-end" type="submit">Save</button>
										</div>
									</div>
	
								</div>
							</form>
						 </div>
					  </div>
				   </div>
				</div>
			 </div>
 
	</div>
 </template>

<script setup>
import Swal from '@/utils/swal';
import { get, post } from '@/utils/api';
import { routes } from '@/constants/routes';
import { onMounted, ref } from 'vue';
import { useRouter, useRoute } from 'vue-router';
import { goBack } from '@/utils/urlHider';

const router = useRouter();
const route = useRoute();

const products = ref([]);
const product_id = ref("");
const product_stock = ref("");
const errors = ref({});
const technician_id = route.query.id;

const handleGoBack = () => {
	const success = goBack(router);
	if (!success) {
		// If no history, go to dashboard as fallback
		router.push({ name: 'defaultRoot' });
	}
};

const fetchProducts = () => {

	const params = {
		technician_id: technician_id
	}
	get(routes.TechnicianRemainingProducts, { params }, false)
		.then((response) => {
			if (response.status === 200) {
				console.log(response.data.data);
                products.value = response.data.data;
            } else {
                Swal.fire('', response.data.message || 'Error fetching data', 'error');
            }
		})
		.catch((error) => {
			if (error.response?.status === 422) {
                Swal.fire('', error.response.data.message.technician_id?.[0] || 'Validation error', 'error');
            } else if (error.response?.status === 500) {
                Swal.fire('', error.response.statusText || 'Server error', 'error');
            } else if (error.response?.status === 401) {
                Swal.fire('', error.response.statusText || 'Unauthorized', 'error');
                router.push({ name: 'login' });
            } else {
				Swal.fire('', error.response.data?.message || 'Error occured', 'error');
			}
		});
};

const addTechnicianProducts = () => {

	const formData = new FormData();
	formData.append('product_id', product_id.value);
	formData.append('quantity', product_stock.value);
	formData.append('technician_id', technician_id);

	post(routes.AddTechnicianProduct, formData, false)
		.then((response) => {
			if (response.status === 200) {
                Swal.fire('', response.data.message || 'Technician product added successfully', 'success');
				router.push({ name: 'technician_products', query: { id: technician_id  } });
            } else {
                Swal.fire('', response.data.message || 'Failed to add technician product', 'error');
            }
		})
		.catch((error) => {
			if (error.response?.status === 422) {
                errors.value = error.response.data.message;
            } else if (error.response?.status === 500) {
                Swal.fire('', error.response.statusText || 'Server error', 'error');
            } else if (error.response?.status === 401) {
                Swal.fire('', error.response.statusText || 'Unauthorized', 'error');
                router.push({ name: 'login' });
            } else {
				Swal.fire('', error.response.data?.message || 'Error occured', 'error');
			}
		});

};

onMounted(() => {
	fetchProducts();
})

</script>